module.exports = __webpack_public_path__ + "img/offers-small-light-green.991ab07d.svg";